import { useEffect, useState } from 'react'

/**
 * Reactively tracks whether the viewport matches a mobile media query.
 * Defaults to the Tailwind `md` breakpoint (< 768px), matching the
 * `hidden md:flex` conventions used for hover overlays.
 */
export function useIsMobile(query = '(max-width: 767px)'): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    setIsMobile(mediaQuery.matches)
    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [query])

  return isMobile
}
